<template>
  <div>
    <!-- Overlay for mobile -->
    <div v-if="mobileOpen && !isDesktop" class="sidebar-overlay fixed w-full h-full bg-black-alpha-40 z-40 md:hidden"
      @click="$emit('close-mobile')"></div>

    <aside class="surface-card flex flex-column ease-in-out" :class="[
      'md:relative md:translate-x-0',
      isDesktop ? (collapsed ? 'md:w-5rem ' : 'md:w-18rem') : '',
      !isDesktop && mobileOpen ? 'mobile-open' : '',
      !isDesktop && !mobileOpen ? 'mobile-closed' : ''
    ]">
      <div class="p-4 flex justify-content-center">
        <img :src="topNavlogo" alt="Logo" class="logo max-w-full max-h-full object-contain" />
      </div>

      <div class="overflow-y-auto py-2">
        <ul class="list-none p-0 m-0">
          <li v-for="item in menuItems" :key="item.label"
            class="flex align-items-center mb-2 cursor-pointer hover:surface-hover transition-colors rounded-md mx-2"
            :class="{ 'active-item': isActive(item.to) }">
            <router-link :to="item.to"
              class="flex px-3 py-3 items-center justify-start w-full h-full text-current menu-link no-underline"
              @click="$emit('close-mobile')">
              <i :class="item.icon" class="ml-2 mr-3 text-lg"></i>
              <span class="overflow-hidden whitespace-nowrap Label"
                :class="[collapsed ? 'w-0 opacity-0 hidden' : 'w-auto opacity-100']">
                {{ item.label }}
              </span>
              <span class="Caption w-5 pl-4" v-if="item.test"> Temporary test page </span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="py-1">
        <Divider class="w-full" />
      </div>
      <div class="flex items-center px-4 py-3 cursor-pointer  transition-all duration-200 menu-link"
        @click="logout">
        <i class="pi pi-sign-out ml-2 mr-3 text-lg"></i>
        <span class="overflow-hidden whitespace-nowrap Label"
          :class="[collapsed ? 'w-0 opacity-0 hidden' : 'w-auto opacity-100']">
          Log out
        </span>
      </div>
    </aside>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import Divider from "primevue/divider";
import { useRoute } from 'vue-router';
import topNavlogo from "@/assets/topNavLogo.png";
import { useAuthStore } from "@/stores/authStore";

const props = defineProps({
  collapsed: Boolean,
  mobileOpen: Boolean,
  isDesktop: Boolean,
  role: String
});
const authStore = useAuthStore();
const route = useRoute();

const menuItems = computed(() => {
  if (props.role === 'super_admin' || props.role === 'admin' ) {
    return [
      { label: "Students", icon: "pi pi-graduation-cap", to: "/admin_dashboard" },
      { label: "Tutors", icon: "pi pi-id-card", to: "/admin_dashboard/tutors" },
      { label: "Institutions", icon: "pi pi-building", to: "/admin_dashboard/institutions" },
      { label: "Verification Requests", icon: "pi pi-shield", to: "/admin_dashboard/verificationRequests" },
      { label: "Tutor Payouts", icon: "pi pi-money-bill", to: "/admin_dashboard/tutorPayouts" },
      { label: "Student Reviews", icon: "pi pi-verified", to: "/admin_dashboard/studentReviews" },
      { label: "Grade Management", icon: "pi pi-book", to: "/admin_dashboard/gradeManagement" },
      { label: "Users", icon: "pi pi-users", to: "/admin_dashboard/userList" },
      { label: "Past Papers", icon: "pi pi-file-pdf", to: "/admin_dashboard/pastPapers" },
      // { label: "Payments", icon: "pi pi-wallet", to: "/admin_dashboard/payments", test: true },
      { label: "Discounts", icon: "pi pi-tag", to: "/admin_dashboard/discounts" },
      { label: "Settings", icon: "pi pi-cog", to: "/admin_dashboard/settingsPage" },
    ];
  } else {
    return [];
  }
});

const isActive = (path) => route.path === path;
const logout = () => authStore.logout();
</script>

<style scoped>
.logo {
  width: 170px;
}

.surface-card {
  background-color: var(--accent-50) !important;
  height: 100dvh;
}

aside {
  transition: width 0.5s ease-in-out, transform 0.5s ease-in-out !important;
}

.sidebar-overlay {
  backdrop-filter: blur(1px);
  z-index: 50 !important;
}

.mobile-open,
.mobile-closed {
  position: fixed !important;
  top: 0;
  left: 0;
  z-index: 50;
  width: 16rem;
  height: 100%;
  transition: transform 0.8s ease-in-out !important;
  will-change: transform;
}

.mobile-open {
  transform: translateX(0);
}

.mobile-closed {
  transform: translateX(-100%);
}

.menu-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
}

li {
  border-radius: 4px;
}

li:hover {
  background-color: var(--accent-100) !important;
}

li.active-item {
  background-color: var(--accent-100) !important;
}
</style>
